<script setup lang="ts">
import { computed } from 'vue';
import { useDisplay } from 'vuetify';
import { shortAddress, shortAddressName } from '@/helpers/shortAddress';
import BaseCopyBtn from '../atoms/BaseCopyBtn.vue';
import { copyToClipboard } from '@/helpers/copyToClipboard';

const { smAndDown } = useDisplay();
const props = defineProps({
  address: { type: String, required: true },
  name: { type: String, required: false },
  showAddressSystem: { type: Boolean, default: false },
  addressSystemSize: { type: [Number, String], default: 16 },
  clickToCopy: { type: Boolean, default: false },
  showCopy: { type: Boolean, default: false },
  forceShort: { type: Boolean, default: false },
  ignoreName: { type: Boolean, default: false },
  noMono: { type: Boolean, default: false },
});

const text = computed(() => {
  if (props.name && !props.ignoreName)
    return props.forceShort || smAndDown.value
      ? shortAddressName(props.name)
      : props.name;
  return props.forceShort || smAndDown.value
    ? shortAddress(props.address)
    : props.address;
});

function onClickToCopy() {
  if (!props.clickToCopy) return;
  copyToClipboard(props.address);
}
</script>

<template>
  <div class="d-flex align-center" :class="{ 'font-family-mono': !noMono }">
    <span
      :title="address"
      @click="onClickToCopy"
      :style="{ cursor: clickToCopy ? 'pointer' : 'inherit' }"
    >
      {{ text }}
    </span>
    <base-copy-btn v-if="showCopy" class="ml-1" :text="address"></base-copy-btn>
  </div>
</template>
